import { Link } from 'react-router';

/** Blizzard's trademark and fan-site notice, on every page (the game's art is theirs). */
export const BLIZZARD_NOTICE =
  'World of Warcraft, Warcraft and Blizzard Entertainment are trademarks or registered trademarks of Blizzard Entertainment, Inc. in the U.S. and/or other countries. Game images are the property of Blizzard Entertainment and are used under its fan site guidelines.';

export function Footer() {
  return (
    <footer className="site-footer">
      {/* Reachable from every page: a policy nobody can find is not a policy. */}
      <nav className="footer-links" aria-label="Site information">
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/dmca">Copyright</Link>
        <Link to="/addon">Addon</Link>
      </nav>
      <p>{BLIZZARD_NOTICE}</p>
    </footer>
  );
}
